import { render, staticRenderFns } from "./LiveReminderBox.vue?vue&type=template&id=0dd36ebe&scoped=true"
import script from "./LiveReminderBox.vue?vue&type=script&lang=js"
export * from "./LiveReminderBox.vue?vue&type=script&lang=js"
import style0 from "./LiveReminderBox.vue?vue&type=style&index=0&id=0dd36ebe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd36ebe",
  null
  
)

export default component.exports